"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _formik = require("formik");
var _reactPaymentInputs = require("react-payment-inputs");
var _images = _interopRequireDefault(require("react-payment-inputs/images"));
var Yup = _interopRequireWildcard(require("yup"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));
var _index = _interopRequireDefault(require("./index.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

const paymentValidationSchema = _ref => {
  let {
    cardNumberErrorRequired,
    expireMonthErrorRequired,
    expireYearErrorRequired,
    securityCodeErrorRequired
  } = _ref;
  return Yup.object().shape({
    cardNumber: Yup.string().required(cardNumberErrorRequired),
    expiryMonth: Yup.string().required(expireMonthErrorRequired),
    expiryYear: Yup.string().required(expireYearErrorRequired),
    securityCode: Yup.string().required(securityCodeErrorRequired)
  });
};
const CustomErrorMessage = _ref2 => {
  let {
    message,
    className
  } = _ref2;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.errorMessage, className)
  }, message);
};
const CustomSelect = _ref3 => {
  let {
    name,
    handleChange,
    selectedValue,
    defaultValue,
    options,
    className,
    onBlur
  } = _ref3;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    variant: "outlined",
    className: (0, _clsx.default)(classes.dateSelectInput, selectedValue === '' ? classes.selectDefaultValue : '', 'dateSelectInput', className),
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    "data-testid": "select-".concat(defaultValue),
    value: selectedValue,
    name: name,
    onChange: handleChange,
    displayEmpty: true,
    IconComponent: _KeyboardArrowDown.default,
    native: true
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, defaultValue), options.map(value => /*#__PURE__*/_react.default.createElement("option", {
    key: value,
    value: value
  }, value))));
};
const CustomDatesInput = _ref4 => {
  let {
    label,
    monthValue,
    handleMonthChange,
    yearValue,
    handleYearChange,
    nameMonth,
    nameYear,
    errorMonth,
    errorYear,
    onBlur,
    errorMessageDate,
    dictionaries
  } = _ref4;
  const classes = (0, _index.default)();
  const [month, setMonth] = _react.default.useState(monthValue);
  const [year, setYear] = _react.default.useState(yearValue);
  const months = dictionaries.giftCardInformationFormMonthArray;
  const now = new Date().getUTCFullYear();
  const years = Array(now - (now - 21)).fill('').map((v, idx) => now + idx);
  const handleMonthChangeInternally = event => {
    setMonth(event.target.value);
    handleMonthChange(months.findIndex(monthLabel => monthLabel === event.target.value) + 1);
  };
  const handleYearChangeInternally = event => {
    setYear(event.target.value);
    handleYearChange(event);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.inputWrapper, 'inputWrapper')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.inputLabel
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.inputBox, 'inputSelectBox')
  }, /*#__PURE__*/_react.default.createElement(CustomSelect, {
    name: nameMonth,
    handleChange: handleMonthChangeInternally,
    selectedValue: month,
    defaultValue: dictionaries.giftCardInformationFormMonthDefaultValue,
    options: months,
    className: errorMonth ? 'input-error' : '',
    onBlur: onBlur
  }), /*#__PURE__*/_react.default.createElement(CustomSelect, {
    name: nameYear,
    handleChange: handleYearChangeInternally,
    selectedValue: year,
    defaultValue: dictionaries.giftCardInformationFormYearDefaultValue,
    options: years,
    className: errorYear ? 'input-error' : '',
    onBlur: onBlur
  })), errorMonth || errorYear ? /*#__PURE__*/_react.default.createElement(CustomErrorMessage, {
    message: errorMessageDate
  }) : '');
};
const CustomInput = _ref5 => {
  let {
    name,
    label,
    placeholder,
    value,
    onChange,
    icon = null,
    className,
    error,
    errorMessage,
    inputProps = {},
    onBlur
  } = _ref5;
  const classes = (0, _index.default)();
  const [inputValue, setInputValue] = (0, _react.useState)(value);
  const iconAdornment = icon ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
    position: "end"
  }, icon) : null;
  const handleChange = event => {
    setInputValue(event.target.value);
    onChange(event);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.inputWrapper, 'inputWrapper', className, error ? 'input-error' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.inputLabel
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.inputBox, 'inputBox')
  }, /*#__PURE__*/_react.default.createElement(_OutlinedInput.default, {
    id: name,
    name: name,
    variant: "outlined",
    fullWidth: true,
    placeholder: placeholder,
    endAdornment: iconAdornment,
    value: inputValue,
    onChange: handleChange,
    inputProps: inputProps,
    onBlur: onBlur
  })), error ? /*#__PURE__*/_react.default.createElement(CustomErrorMessage, {
    message: errorMessage
  }) : '');
};
const GiftCardInformationForm = _ref6 => {
  let {
    onFormChange,
    handleSubmitForm,
    giftCards,
    setGiftCards,
    errorHandler,
    setAddAnotherGiftCard,
    handleApplyGiftCardApiCall,
    dictionaries
  } = _ref6;
  const classes = (0, _index.default)();
  const formRef = (0, _react.useRef)();
  const [initialValues, setInitialValues] = (0, _react.useState)({
    cardNumber: '',
    expiryMonth: '',
    expiryYear: '',
    securityCode: ''
  });
  const ERROR_MESSAGES = {
    emptyCardNumber: dictionaries.giftCardInformationFormEmptyCardNumber,
    invalidCardNumber: dictionaries.giftCardInformationFormInvalidCardNumber
  };
  const {
    meta,
    getCardNumberProps,
    getCardImageProps
  } = (0, _reactPaymentInputs.usePaymentInputs)({
    errorMessages: ERROR_MESSAGES
  });
  const handleReset = values => {
    setInitialValues({
      cardNumber: '',
      expiryMonth: '',
      expiryYear: '',
      securityCode: ''
    });
    setAddAnotherGiftCard(false);
  };
  (0, _react.useEffect)(() => {
    handleSubmitForm(formRef);
    // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    enableReinitialize: true,
    innerRef: formRef,
    initialValues: initialValues,
    validationSchema: paymentValidationSchema({
      cardNumberErrorRequired: dictionaries.giftCardInformationFormCardNumberErrorRequired,
      expireMonthErrorRequired: dictionaries.giftCardInformationFormExpireMonthErrorRequired,
      expireYearErrorRequired: dictionaries.giftCardInformationFormExpireYearErrorRequired,
      securityCodeErrorRequired: dictionaries.giftCardInformationFormSecurityCodeErrorRequired
    }),
    validate: values => {
      const errors = {};
      if (values.expiryMonth && values.expiryYear) {
        const position = values.expiryMonth - 1;
        const currentDate = new Date();
        const selectedDate = new Date();
        selectedDate.setMonth(position);
        selectedDate.setYear(values.expiryYear);
        if (selectedDate < currentDate) {
          errors.expiryMonth = dictionaries.giftCardInformationFormExpireMonthErrorRequired;
        }
      }
      if (values.expiryMonth === 0) {
        errors.expiryMonth = dictionaries.giftCardInformationFormExpireMonthErrorRequired;
      }
      if (values.securityCode) {
        const RegExpression = /^\d+$/;
        if (values.securityCode.length !== 3) {
          errors.securityCode = dictionaries.giftCardInformationFormSecurityCodeErrorThreeDigitsOnly;
        }
        if (!RegExpression.test(values.securityCode)) {
          errors.securityCode = dictionaries.giftCardInformationFormSecurityCodeErrorOnlyNumbers;
        }
      }
      if (values.cardNumber) {
        if (!values.cardNumber.startsWith('4754 8023 3', 0)) {
          errors.cardNumber = dictionaries.giftCardInformationFormCardNumberErrorInvalid;
        }
      }
      return errors;
    },
    onSubmit: (values, actions) => {
      actions.setSubmitting(false);
      if (!meta.error) {
        // Api apply giftcard request call should be here.
        const giftCardsAdded = [...giftCards];
        const giftCardExist = giftCardsAdded.find(info => info.cardNumber === values.cardNumber);
        if (!giftCardExist) {
          const payload = {
            cardNumber: values.cardNumber,
            expiryMonth: values.expiryMonth,
            expiryYear: values.expiryYear,
            securityCode: values.securityCode
          };
          handleApplyGiftCardApiCall(payload).then(res => {
            const giftCardInfo = {
              ...res
            };
            giftCardsAdded.push(giftCardInfo);
            setGiftCards(giftCardsAdded);
            actions.resetForm();
          });
        } else {
          errorHandler(dictionaries.giftCardInformationFormCreditCardAlreadyExistErrorTitle, dictionaries.giftCardInformationFormCreditCardAlreadyExistErrorDescription);
        }
      }
    },
    onReset: handleReset
  }, _ref7 => {
    let {
      errors,
      touched,
      values,
      handleSubmit,
      handleChange,
      handleBlur,
      setFieldValue
    } = _ref7;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, {
      id: "submit-checkout-form",
      "data-testid": "giftcardForm",
      ref: formRef,
      onSubmit: e => {
        e.preventDefault();
        handleSubmit();
      },
      className: classes.giftCardForm
    }, onFormChange({
      card: meta,
      errors
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.inputBoxWrapper
    }, /*#__PURE__*/_react.default.createElement(CustomInput, {
      id: "card-number-id",
      name: "cardNumber",
      label: dictionaries.giftCardInformationFormCardNumberLabel,
      placeholder: dictionaries.giftCardInformationFormCardNumberPlaceholder,
      value: values.cardNumber,
      onChange: event => setFieldValue('cardNumber', event.target.value),
      icon: /*#__PURE__*/_react.default.createElement("svg", getCardImageProps({
        images: _images.default
      })),
      className: "no-right-padding",
      error: meta.touchedInputs.cardNumber && typeof meta.erroredInputs.cardNumber !== 'undefined' || errors.cardNumber && touched.cardNumber,
      errorMessage: meta.touchedInputs.cardNumber && meta.erroredInputs.cardNumber || errors.cardNumber,
      inputProps: {
        ...getCardNumberProps({
          onChange: handleChange,
          onBlur: handleBlur
        }),
        'data-testid': 'card-number',
        placeholder: dictionaries.giftCardInformationFormCardNumberPlaceholder
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.expirationAndSecurityCodeWrapper
    }, /*#__PURE__*/_react.default.createElement(CustomDatesInput, {
      label: dictionaries.giftCardInformationFormExpirationDateLabel,
      nameMonth: "expiryMonth",
      nameYear: "expiryYear",
      monthValue: values.expiryMonth,
      handleMonthChange: monthNumber => setFieldValue('expiryMonth', monthNumber),
      yearValue: values.expiryYear,
      handleYearChange: event => setFieldValue('expiryYear', event.target.value),
      errorMonth: errors.expiryMonth && touched.expiryMonth,
      errorYear: errors.expiryYear && touched.expiryYear,
      errorMessageDate: errors.expiryMonth,
      onBlur: handleBlur,
      dictionaries: dictionaries
    }), /*#__PURE__*/_react.default.createElement(CustomInput, {
      id: "security-code",
      name: "securityCode",
      className: "securityCode",
      label: dictionaries.giftCardInformationFormSecurityCodeLabel,
      placeholder: dictionaries.giftCardInformationFormSecurityCodePlaceholder,
      value: values.securityCode,
      onChange: event => setFieldValue('securityCode', event.target.value),
      error: errors.securityCode && touched.securityCode,
      errorMessage: errors.securityCode,
      inputProps: {
        'data-testid': 'security-code'
      },
      onBlur: handleBlur
    }))));
  });
};
var _default = exports.default = GiftCardInformationForm;